import { createColumnHelper } from '@tanstack/react-table';
import { ClientHoverCard } from 'components/ClientHoverCard';
import { i18nKeys, useTranslation } from 'locales';
import { useMemo } from 'react';
import type { AiCall } from '../api/use-load-ai-call';

const columnHelper = createColumnHelper<AiCall>();

export function useBuildAiCallColumns() {
  const { t } = useTranslation();

  return useMemo(
    () => [
      columnHelper.accessor('invoiceReference', {
        header: t(i18nKeys.AI_CALLS.COLUMNS.REFERENCE),
      }),
      columnHelper.accessor('debtorName', {
        header: t(i18nKeys.AI_CALLS.COLUMNS.CLIENT),
        cell: info => {
          const { debtorName, debtorId } = info.row.original;
          return <ClientHoverCard debtorId={debtorId} debtorName={debtorName} />;
        },
      }),
      columnHelper.accessor('feedback.outcome', {
        header: t(i18nKeys.AI_CALLS.COLUMNS.OUTCOME),
        cell: status => status.getValue() ?? '-',
      }),
      columnHelper.accessor('feedback.endReason', {
        header: t(i18nKeys.AI_CALLS.COLUMNS.END_REASON),
        cell: status => status.getValue() ?? '-',
      }),
      columnHelper.accessor('feedback', {
        header: t(i18nKeys.AI_CALLS.COLUMNS.CALL_DATE),
        cell: feedback => {
          const feedbackData = feedback.getValue();
          return feedbackData?.startedAt ? feedbackData.startedAt.format('DD/MM/YYYY HH:mm') : '-';
        },
      }),
    ],
    [t],
  );
}
